import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _TakeStem;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import sortBy from 'lodash/fp/sortBy';
import map from 'lodash/fp/map';
import flatten from 'lodash/fp/flatten';
import find from 'lodash/fp/find';
import flow from 'lodash/fp/flow';
import { v4 as uuid } from 'uuid';
import { jsx, css } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import { ItemBodyWrapper } from '@instructure/quiz-rce';
import BlankDropTarget from '../../drag_components/BlankDropTarget';
import { trimPunctuation, getTrimmedPunctuation } from '../../helpers/punctuation';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { SimpleSelect, TextInput, withStyleOverrides } from '@instructure/quiz-common';
var TakeStem = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_TakeStem = /*#__PURE__*/function (_Component) {
  function TakeStem() {
    var _this2;
    _classCallCheck(this, TakeStem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, TakeStem, [].concat(args));
    _defineProperty(_this2, "state", {
      isMounted: false
    });
    _defineProperty(_this2, "id", uuid());
    _defineProperty(_this2, "updateWordBankUserResponse", function (blankId) {
      return function (choice) {
        var wordBankChoices = _this2.props.interactionData.wordBankChoices;
        var choiceValue = wordBankChoices ? choice.itemBody : choice.id;
        _this2.updateUserResponse(blankId, choiceValue);
      };
    });
    _defineProperty(_this2, "renderStemItem", function (stemItem) {
      if (stemItem.type === 'text') {
        return jsx(Text, {
          color: "primary",
          key: stemItem.id
        }, trimPunctuation(stemItem, _this2.props.interactionData.stemItems));
      }
      var blank = find({
        id: stemItem.blankId
      }, _this2.props.interactionData.blanks);
      var punctuation = getTrimmedPunctuation(stemItem, _this2.props.interactionData.stemItems);
      return jsx("span", {
        key: stemItem.id,
        className: "stemItem",
        css: _this2.props.styles.stemItem
      }, punctuation.start, _this2.renderBlank(blank), punctuation.end);
    });
    _defineProperty(_this2, "renderRichBlanks", function () {
      if (_this2.state.isMounted) {
        var questionWrapper = document.getElementById(_this2.id);
        return _this2.props.interactionData.blanks.map(function (blank) {
          if (questionWrapper.querySelector("#blank_".concat(blank.id))) {
            return ReactDOM.createPortal(_this2.renderBlank(blank), questionWrapper.querySelector("#blank_".concat(blank.id)));
          }
        });
      }
    });
    return _this2;
  }
  _inherits(TakeStem, _Component);
  return _createClass(TakeStem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }

    // =============
    //   HELPERS
    // =============
  }, {
    key: "getWordbankChoiceByResponseValue",
    value: function getWordbankChoiceByResponseValue(responseValue) {
      if (this.props.interactionData.wordBankChoices) {
        return this.props.interactionData.wordBankChoices.find(function (choice) {
          return choice.itemBody === responseValue;
        });
      }
      return this.getWordbankChoiceById(responseValue);
    }
  }, {
    key: "getWordbankChoiceById",
    value: function getWordbankChoiceById(choiceId) {
      return flow(map(function (b) {
        return b.answerType === 'wordbank' ? b.choices : [];
      }), flatten, find({
        id: choiceId
      }))(this.props.interactionData.blanks);
    }
  }, {
    key: "updateUserResponse",
    value: function updateUserResponse(blankId, blankValue) {
      var newResponses = this.props.userResponses.filter(function (blank) {
        return blank.id !== blankId;
      }).concat([{
        id: blankId,
        value: blankValue,
        type: 'Text'
      }]);
      this.props.onUpdate(newResponses);
    }
  }, {
    key: "getValueForBlank",
    value: function getValueForBlank(blankId) {
      var objectForBlank = this.props.userResponses.find(function (response) {
        return response.id === blankId;
      });
      return objectForBlank && 'value' in objectForBlank ? objectForBlank.value : null;
    }

    // =============
    //   RENDERING
    // =============
  }, {
    key: "renderDropdown",
    value: function renderDropdown(blank, blankSRText) {
      var _this3 = this;
      var selectOptionIdPrefix = 'take-stem-select-option-';
      var selectedChoiceId = this.getValueForBlank(blank.id);
      var choice = blank.choices.find(function (choice) {
        return choice.id === selectedChoiceId;
      });
      var mountNodeId = "mountNode_".concat(blank.id);
      return jsx(React.Fragment, null, jsx("div", {
        css: this.props.styles.printBlank
      }, jsx(TextInput, {
        display: "inline-block",
        renderLabel: jsx(ScreenReaderContent, null, t('Printed Blank')),
        interaction: "readonly",
        defaultValue: choice && choice.itemBody
      })), jsx("div", {
        className: "fs-mask",
        css: this.props.styles.noPrintBlank
      }, jsx(SimpleSelect, {
        value: this.getValueForBlank(blank.id),
        renderLabel: jsx(ScreenReaderContent, null, blankSRText),
        onChange: function onChange(event, _ref) {
          var value = _ref.value;
          return _this3.updateUserResponse(blank.id, value);
        },
        interaction: this.props.readOnly ? 'readonly' : 'enabled',
        mountNode: function mountNode() {
          return document.getElementById(mountNodeId);
        }
      }, jsx(SimpleSelect.Option, {
        id: "take-stem-select-option-empty",
        value: "",
        style: css(this.props.styles.selectPlaceholder).styles
      }, t('choose your answer...')), blank.choices.map(function (choice) {
        return jsx(SimpleSelect.Option, {
          id: selectOptionIdPrefix + choice.id,
          key: choice.id,
          value: choice.id
        }, choice.itemBody);
      })), jsx("div", {
        id: mountNodeId
      })));
    }
  }, {
    key: "renderWordbankBlank",
    value: function renderWordbankBlank(blank, blankSRText) {
      var _this4 = this;
      var blankResponseValue = this.getValueForBlank(blank.id);
      var choice = this.getWordbankChoiceByResponseValue(blankResponseValue);
      return jsx(React.Fragment, null, jsx("div", {
        css: this.props.styles.printBlank
      }, jsx(TextInput, {
        display: "inline-block",
        renderLabel: jsx(ScreenReaderContent, null, t('Printed Blank')),
        interaction: "readonly",
        defaultValue: choice && choice.itemBody
      })), jsx("div", {
        className: "fs-mask",
        css: this.props.styles.noPrintBlank
      }, jsx(ScreenReaderContent, null, blankSRText), jsx(BlankDropTarget, {
        key: blank.id,
        choices: this.props.wordBankChoices,
        choice: choice,
        blankId: blank.id,
        onChange: this.updateWordBankUserResponse(blank.id),
        onDrop: this.updateWordBankUserResponse(blank.id),
        readOnly: this.props.readOnly,
        returnChoiceToWordbank: function returnChoiceToWordbank(choiceId) {
          return _this4.props.returnChoiceToWordbank(blank.id, choiceId);
        }
      })));
    }
  }, {
    key: "renderOpenEntry",
    value: function renderOpenEntry(blank, blankSRText) {
      var _this5 = this;
      var value = this.getValueForBlank(blank.id);
      return jsx("span", {
        className: "fs-mask"
      }, jsx(TextInput, {
        display: "inline-block",
        renderLabel: jsx(ScreenReaderContent, null, blankSRText),
        placeholder: t('type your answer...')
        // use defaultValue for Take (uncontrolled)
        ,
        defaultValue: this.props.readOnly ? void 0 : value
        // use value for Show (controlled, so it updates when changed)
        ,
        value: this.props.readOnly ? value : void 0,
        onChange: function onChange(e) {
          return _this5.updateUserResponse(blank.id, e.target.value.trim());
        },
        interaction: this.props.readOnly ? 'readonly' : 'enabled',
        "data-automation": "sdk-fitb-taking-answer",
        autoComplete: "off"
      }));
    }
  }, {
    key: "renderBlank",
    value: function renderBlank(blank) {
      var blankPosition = this.props.interactionData.blanks.indexOf(blank) + 1;
      var blankSRText = t('Question Blank { blankPosition } of { totalBlanks }', {
        blankPosition: blankPosition,
        totalBlanks: this.props.interactionData.blanks.length
      });
      switch (blank.answerType) {
        case 'openEntry':
          return this.renderOpenEntry(blank, blankSRText);
        case 'dropdown':
          return this.renderDropdown(blank, blankSRText);
        default:
          return this.renderWordbankBlank(blank, blankSRText);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.richFITB) {
        return jsx(ItemBodyWrapper, {
          id: this.id,
          itemBody: this.props.itemBody
        }, this.renderRichBlanks());
      }
      return jsx("div", {
        css: this.props.styles.stemWrapper,
        "data-automation": "take-stem-wrapper"
      }, flow(sortBy(['position']), map(this.renderStemItem))(this.props.interactionData.stemItems));
    }
  }]);
}(Component), _defineProperty(_TakeStem, "displayName", 'TakeStem'), _defineProperty(_TakeStem, "componentId", "Quizzes".concat(_TakeStem.displayName)), _defineProperty(_TakeStem, "propTypes", {
  onUpdate: PropTypes.func.isRequired,
  interactionData: PropTypes.object.isRequired,
  itemBody: PropTypes.string,
  returnChoiceToWordbank: PropTypes.func,
  userResponses: PropTypes.array,
  readOnly: PropTypes.bool,
  richFITB: PropTypes.bool,
  wordBankChoices: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    itemBody: PropTypes.string
  })),
  styles: PropTypes.object
}), _defineProperty(_TakeStem, "defaultProps", {
  itemBody: '',
  returnChoiceToWordbank: void 0,
  userResponses: [],
  readOnly: false,
  richFITB: false,
  wordBankChoices: void 0
}), _TakeStem)) || _class);
export { TakeStem as default };